export default {
  "kisok-002": "dcp", // kisok stagging
  "kisok-001": "netplusFR_01", // NET-M1-003
  "kisok-003": "netplus", // NET-M1-001
  "kisok-004": "SEFA", // NET-M1-006
  "kisok-005": "netplus_Entremont", // NET-M1-008
  "kisok-006": "SIL", // NET-M1-005
  "kisok-007": "genedis", // NET-M1-002
  "kisok-008": "SEVJ", // NET-M1-004
  "kisok-009": "netplusFR_02", // NET-M1-007
  "TEST-GENEDIS": "genedis",
  "kisok-2604031517": "dcp", // borne de test pour le développment
  "DESKTOP-AJJMJ37": "genedis", // borne proto
  "NET-M1-2": "genedis", // borne de remplacement de la borne proto installée le 18.11.2025
}